import { Provider } from '@angular/core';
import { NgbConfig } from '@ng-bootstrap/ng-bootstrap';

export function createNgbConfig(): NgbConfig {
  const config = new NgbConfig();
  // Preserve pre-v8 transition timing while migrating existing modal/popover flows.
  config.animation = false;
  return config;
}

export const ngBootstrapConfigProvider: Provider = { provide: NgbConfig, useFactory: createNgbConfig };
